import React from 'react'

export const Curriculum = () => {
  return (
    <div>
        {/* <!-- Contenido principal  --> */}
        <main className="layout__content">
            <section className="content__page content__resume">
                
                <header className="resume__header">
                    <h2 className="resume__title">Curriculum</h2>
                </header>

                <div className="resume__cointiner">
                    <section className="resume_left">
                        <header className="resume__subheader">
                            <h2 className="resume__subtitle">Formación</h2>
                        </header>

                        <div className="resume__timelines">
                            <article className="timelines__timeline">
                                <header className="timeline__header">
                                    <h4 className="timeline_year">1988 - 1992</h4>
                                    <span className="timeline__company">UNAM - Enep Acatlán, CDMX</span>
                                </header>
                                <div className="timeline__divider"></div>
                                <div className="timeline__description">
                                    <h3 className="timeline__title">Architecture</h3>
                                    <p className="timeline__text">
                                        Architecture - Bachelor's degree
                                    </p>
                                </div>
                            </article>
                            <article className="timelines__timeline">
                                <header className="timeline__header">
                                    <h4 className="timeline_year">2003 - 2005</h4>
                                    <span className="timeline__company">Fundacióл Arturo Rosenblueth, CDMX</span>
                                </header>
                                <div className="timeline__divider"></div>
                                <div className="timeline__description">
                                    <h3 className="timeline__title">information systems</h3>
                                    <p className="timeline__text">
                                        Master’s degree in information systems
                                    </p>
                                </div>
                            </article>
                        </div>

                        <header className="resume__subheader">
                            <h2 className="resume__subtitle">Experiencia</h2>
                        </header>
                        <div className="resume__timelines">
                            <article className="timelines__timeline">
                                <header className="timeline__header">
                                    <h4 className="timeline_year">2013 - 2024</h4>
                                    <span className="timeline__company">NIELSEN IBOPE MÉXICO S.A., CDMX</span>
                                </header>
                                <div className="timeline__divider"></div>
                                <div className="timeline__description">
                                    <h3 className="timeline__title">Project Manager Latam / Scrum master / Web Developer</h3>
                                    <p className="timeline__text">
                                        <li>-Development of internal and client web applications in javascript, nodejs, jquery, laravel, HTML, CSS, React and wordpress languages (5 years)</li>
                                        <li>-Management of medium and large projects under the Agile methodology ( daily standup, retrospective meetings, sprint planning, removing obstacles and managing the backlog) - 11 years.</li>
                                        <li>-Develop systems for clients to analyze produced data or raw data information: requirements management, change control and implementation of final products ( work as Product owner in some cases) and manage budget tracking with AgileCraft tool (including the process with providers). </li>
                                        <li> Design development of data warehouse (DW) and Extract, Transform and Load (ETL) processes, For business intelligence (BI), AI/ML and analysis.</li>
                                        <li>-Support for applications for Customers and internal users for 6 countries ( Puerto Rico, Mexico, Denmark, Italy, South Africa and Australia)  through the Itil methodology and service now (tickets).</li>
                                        <li>
                                            -Architecture design and management of cloud services with AWS and Microsoft Azure.
                                                Creating information collection systems in the cloud and being able to support work at home.
                                                Client systems where web applications are published with high availability, load balancing and security
                                        </li>
                                        <li>Quality process, test cases, test strategy, regression test or just smoke test, plan the testing strategy, as well as automate if required</li>
                                        <li>
                                            Design dashboards that allow the Digital service client to know the behavior of their brand and the competition by taking different data sources based on the following:
                                        Measurements: investment, impressions, market share, # insertions, etc.
                                        Dimensions: advertiser, Brand, category, Media owner, advertiser domain, publisher domain, etc.
                                        </li>
                                        <li> Using standard ETL process and OasServer as a front end</li>
                                    </p>
                                </div>
                            </article>
                            <article className="timelines__timeline">
                                <header className="timeline__header">
                                    <h4 className="timeline_year">1998 - 2013</h4>
                                    <span className="timeline__company">Ibope AGB México S.A, CDMX</span>
                                </header>
                                <div className="timeline__divider"></div>
                                <div className="timeline__description">
                                    <h3 className="timeline__title">Deputy Director of Information Technology / Systems Development Manager / Developer</h3>
                                    <p className="timeline__text">
                                        <li>Monitoring of electoral campaigns (2006) in MX, advertising investment campaigns of the different political parties in 30 states and showing the results in a panel developed in Cognos and QlikView, Extract, Transform and Load (ETL) through pentaho and SQL services</li>
                                        <li>Implementing ISO2700 security certification</li>
                                        <li>Support for finance systems such as SAP</li>
                                        <li>Knowledge and development in object-oriented programming languages, such as Visual Basic, C#, C++, java and python.</li>
                                        <li>Database Administrator in Postgresql / DB2As400 / MS SQL.</li>
                                        <li>Develop production systems for advertising monitoring: outdoor, radio audience and television audience</li>
                                        <li>Develop systems for clients to collect and analyze the information produced</li>
                                        <li>Production of databases in different formats for clients</li>
                                        <li>In charge of the technical support and customer service department</li>
                                        <li>Network and telecommunications equipment administrator.</li>
                                    </p>
                                </div>
                            </article>
                            <article className="timelines__timeline">
                                <header className="timeline__header">
                                    <h4 className="timeline_year">1997 - 1998</h4>
                                    <span className="timeline__company">STC direct S.A De C.V., CDMX</span>
                                </header>
                                <div className="timeline__divider"></div>
                                <div className="timeline__description">
                                    <h3 className="timeline__title">Developer</h3>
                                    <p className="timeline__text">
                                        <li>Develop production system</li>
                                        <li>Data standardization </li>
                                        <li>Call center</li>
                                    </p>
                                </div>
                            </article>
                            <article className="timelines__timeline">
                                <header className="timeline__header">
                                    <h4 className="timeline_year">1992 - 1997</h4>
                                    <span className="timeline__company">Centro universitario Patria A.C, CDMX</span>
                                </header>
                                <div className="timeline__divider"></div>
                                <div className="timeline__description">
                                    <h3 className="timeline__title">Teacher</h3>
                                    <p className="timeline__text">
                                        <li>Constructive drawing</li>
                                        <li>modeling</li>
                                        <li>Algebra and trigonometry</li>
                                        <li>Programming languages</li>
                                        <li>computer systems</li>                                        
                                    </p>
                                </div>
                            </article>

                        </div>

                    </section>
                    <section className="resume_rigth">
                        <header className="resume__subheader">
                            <h2 className="resume__subtitle">Habilidades de <span className="subtitle__color">diseño</span></h2>
                        </header>
                        <div className="resume__skills">

                            <article className="skills__title">
                                <h4 className="skills__text">Diseño web</h4>
                                <span className="skills__number">90%</span>
                            </article>
                            <div className="skills__progressbar">
                                <div className="skills__percentage skills__percentag--p1"></div>
                            </div>

                            <article className="skills__title">
                                <h4 className="skills__text">Diseño dashboards</h4>
                                <span className="skills__number">85%</span>
                            </article>
                            <div className="skills__progressbar">
                                <div className="skills__percentage skills__percentag--p2"></div>
                            </div>

                            <article className="skills__title">
                                <h4 className="skills__text">Diseño logos</h4>
                                <span className="skills__number">100%</span>
                            </article>
                            <div className="skills__progressbar">
                                <div className="skills__percentage skills__percentag--p3"></div>
                            </div>

                            <article className="skills__title">
                                <h4 className="skills__text">Diseño banners</h4>
                                <span className="skills__number">80%</span>
                            </article>
                            <div className="skills__progressbar">
                                <div className="skills__percentage skills__percentag--p4"></div>
                            </div>

                        </div>

                        <header className="resume__subheader">
                            <h2 className="resume__subtitle">Habilidades de <span className="subtitle__color">código</span></h2>
                        </header>
                        <div className="resume__skills">
                            <article className="skills__title">
                                <h4 className="skills__text">HTML/CSS</h4>
                                <span className="skills__number">100%</span>
                            </article>
                            <div className="skills__progressbar">
                                <div className="skills__percentage skills__percentag--p5"></div>
                            </div>

                            <article className="skills__title">
                                <h4 className="skills__text">Javascript</h4>
                                <span className="skills__number">85%</span>
                            </article>
                            <div className="skills__progressbar">
                                <div className="skills__percentage skills__percentag--p6"></div>
                            </div>

                            <article className="skills__title">
                                <h4 className="skills__text">React</h4>
                                <span className="skills__number">80%</span>
                            </article>
                            <div className="skills__progressbar">
                                <div className="skills__percentage skills__percentag--p7"></div>
                            </div>

                            <article className="skills__title">
                                <h4 className="skills__text">Laravel/ PHP</h4>
                                <span className="skills__number">80%</span>
                            </article>
                            <div className="skills__progressbar">
                                <div className="skills__percentage skills__percentag--p8"></div>
                            </div>

                            <article className="skills__title">
                                <h4 className="skills__text">Wordpress</h4>
                                <span className="skills__number">70%</span>
                            </article>
                            <div className="skills__progressbar">
                                <div className="skills__percentage skills__percentag--p9"></div>
                            </div>
                        </div>

                        <header className="resume__subheader">
                            <h2 className="resume__subtitle">Other knowledge</h2>
                        </header>
                        <div className="resume__knowledges">
                            <ul className="knowledges__list">
                                <li className="knowledges__option"><span className="c0">Nodejs</span></li>
                                <li className="knowledges__option"><span className="c0">javascript</span></li>
                                <li className="knowledges__option"><span className="c0">HTML 5/ CSS</span></li>
                                <li className="knowledges__option"><span className="c0">Angular</span></li>
                                <li className="knowledges__option"><span className="c0">React</span></li>
                                <li className="knowledges__option"><span className="c0">Laravel</span></li>
                                <li className="knowledges__option"><span className="c0">Wordpress</span></li>
                                <li className="knowledges__option"><span className="c0">Jquery</span></li>
                                <li className="knowledges__option"><span className="c0">postman</span></li>
                                <li className="knowledges__option"><span className="c0">AWS - cloud deployment (EC2, automation Terraform)</span></li>
                                <li className="knowledges__option"><span className="c0">Microsoft Azure (basic)</span></li>
                                <li className="knowledges__option"><span className="c0">QA - test strategic and metrics</span></li>
                                <li className="knowledges__option"><span className="c0">Test cases automation with Selenium</span></li>
                                <li className="knowledges__option"><span className="c0">JIRA</span></li>
                                <li className="knowledges__option"><span className="c0">GIT LAB</span></li>
                                <li className="knowledges__option"><span className="c0">Agilecraft</span></li>
                                <li className="knowledges__option"><span className="c0">Visual Foxpro expert</span></li>
                                <li className="knowledges__option"><span className="c0">Visual Basic expert</span></li>
                                <li className="knowledges__option"><span className="c0">C#</span></li>
                                <li className="knowledges__option"><span className="c0">RPGLE IV</span></li>
                                <li className="knowledges__option"><span className="c0">Cognos</span></li>
                                <li className="knowledges__option"><span className="c0">Micro strategic BI</span></li>
                                <li className="knowledges__option"><span className="c0">Genexus</span></li>
                                <li className="knowledges__option"><span className="c0">Microsoft project</span></li>
                                <li className="knowledges__option"><span className="c0">ETL - Pentaho</span></li>
                                <li className="knowledges__option"><span className="c0">SAP - Implementation</span></li>
                                <li className="knowledges__option"><span className="c0">ERP local </span></li>
                                <li className="knowledges__option"><span className="c0">Visio</span></li>
                                <li className="knowledges__option"><span className="c0">Autocad</span></li>
                                <li className="knowledges__option"><span className="c0">sketch up</span></li>
                            </ul>
                            <h4 className="c7">DBA - database administrator (backups, restor, maintenance etc.)</h4>
                            <ul className="knowledges__list">
                                <li className="knowledges__option"><span className="c0">MongoDB</span></li>
                                <li className="knowledges__option"><span className="c0">Microsoft SQL</span></li>
                                <li className="knowledges__option"><span className="c0">postgreSQL - DBA</span></li>
                                <li className="knowledges__option"><span className="c0">MySQL</span></li>
                                <li className="knowledges__option"><span className="c0">DB2 - 400</span></li>
                            </ul>
                        </div>
                    </section>
                </div>
            </section>

        </main>
    </div>
  )
}
